
export class Building {
  $key: string;
  name: string;
  constructor(values: Object = {}) {

    Object.assign(this, values);

  };

}



// WEBPACK FOOTER //
// ./src/app/building/shared/building.ts